import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IPointAllocationSystem } from 'app/shared/model/point-allocation-system.model';
import { getEntities as getPointAllocationSystems } from 'app/entities/point-allocation-system/point-allocation-system.reducer';
import { IAchivements } from 'app/shared/model/achivements.model';
import { getEntity, updateEntity, createEntity, reset } from './achivements.reducer';

export const AchivementsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pointAllocationSystems = useAppSelector(state => state.pointAllocationSystem.entities);
  const achivementsEntity = useAppSelector(state => state.achivements.entity);
  const loading = useAppSelector(state => state.achivements.loading);
  const updating = useAppSelector(state => state.achivements.updating);
  const updateSuccess = useAppSelector(state => state.achivements.updateSuccess);

  const handleClose = () => {
    navigate('/achivements' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPointAllocationSystems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...achivementsEntity,
      ...values,
      pointAllocationSystem: pointAllocationSystems.find(it => it.id.toString() === values.pointAllocationSystem.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...achivementsEntity,
          pointAllocationSystem: achivementsEntity?.pointAllocationSystem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.achivements.home.createOrEditLabel" data-cy="AchivementsCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.achivements.home.createOrEditLabel">Create or edit a Achivements</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="achivements-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.achivements.name')}
                id="achivements-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.achivements.description')}
                id="achivements-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.achivements.feature')}
                id="achivements-feature"
                name="feature"
                data-cy="feature"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fivePlusApp.achivements.requiredProof')}
                id="achivements-requiredProof"
                name="requiredProof"
                data-cy="requiredProof"
                check
                type="checkbox"
              />
              <ValidatedField
                id="achivements-pointAllocationSystem"
                name="pointAllocationSystem"
                data-cy="pointAllocationSystem"
                label={translate('fivePlusApp.achivements.pointAllocationSystem')}
                type="select"
              >
                <option value="" key="0" />
                {pointAllocationSystems
                  ? pointAllocationSystems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/achivements" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AchivementsUpdate;
